import React from 'react';

type BrandLogoProps = {
  text?: string;
  size?: number;
  showIcon?: boolean;
  color?: string;
  iconColor?: string;
  style?: React.CSSProperties;
};

export const BrandIcon: React.FC<{ size?: number; color?: string }> = ({ size = 40, color = '#0B6B6F' }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" role="img" aria-label="Belivah icon" style={{ flexShrink: 0 }}>
    <defs>
      <linearGradient id="belivah-icon-grad" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#66EAD1" />
        <stop offset="100%" stopColor={color} />
      </linearGradient>
    </defs>
    <circle cx="32" cy="32" r="30" fill="url(#belivah-icon-grad)" />
    <circle cx="32" cy="32" r="30" fill="none" stroke="#fff" strokeOpacity="0.35" strokeWidth="2" />
    <path d="M32 12v40M21 24h22" stroke="#fff" strokeWidth="5" strokeLinecap="round" />
    <path d="M14 44c6-6 12-8 18-8s12 2 18 8" fill="none" stroke="#fff" strokeOpacity="0.8" strokeWidth="3" strokeLinecap="round" />
  </svg>
);

const BrandLogo: React.FC<BrandLogoProps> = ({
  text = 'Belivah',
  size = 40,
  showIcon = true,
  color = 'inherit',
  iconColor,
  style,
}) => (
  <span style={{ display: 'inline-flex', alignItems: 'center', gap: Math.round(size * 0.25), lineHeight: 1, ...style }}>
    {showIcon && <BrandIcon size={Math.round(size * 1.1)} color={iconColor} />}
    <span
      className="belivah-logo-text"
      style={{
        fontFamily: "'Dancing Script', 'Brush Script MT', cursive",
        fontWeight: 700,
        fontSize: size,
        letterSpacing: '0.5px',
        color,
        whiteSpace: 'nowrap',
      }}
    >
      {text}
    </span>
  </span>
);

export default BrandLogo;
